module.exports = __webpack_public_path__ + "static/media/Xiaohui Chen.fb1f206c.jpg";